import { useState, MouseEvent, FC } from 'react';

import { Download, Trash2, Pencil, ListChecks } from 'lucide-react';
import { BaseMenu, BaseMenuItem } from 'wbs-components-lib';

import { Box, Typography } from '@mui/material';

import { VipTaskItemTypesEnum } from '@shared/constants';
import { textStyles } from '@shared/styles';

import { VipTaskItemProps } from './types';

import styles from './VipTaskItem.module.css';

const { actionsContainer, vipTaskActionItem } = styles;

const { defaultText } = textStyles;

export const VipTaskItem: FC<VipTaskItemProps> = ({
  vipTask,
  vipTaskItem,
  handleVipTaskItemEditModalOpen,
  handleVipTaskItemDeleteModalOpen,
  handleVipTaskItemExport,
  handleVipTaskItemValidateModalOpen,
}) => {
  const { id, title, reward, type } = vipTaskItem;

  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const isMenuOpened = Boolean(menuAnchor);

  const handleOpenMenu = (event: MouseEvent<HTMLElement>) => {
    setMenuAnchor(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setMenuAnchor(null);
  };

  const menuItems: BaseMenuItem[] = [
    {
      icon: <Pencil />,
      text: 'Edit',
      onClick: () => handleVipTaskItemEditModalOpen(vipTask, vipTaskItem),
    },
    {
      icon: <Trash2 />,
      text: 'Delete',
      onClick: () => handleVipTaskItemDeleteModalOpen(vipTask, vipTaskItem),
    },
  ];

  if (type === VipTaskItemTypesEnum.VALIDATE_PARTNER_ACTION) {
    menuItems.push(
      {
        icon: <Download />,
        text: 'Export participants',
        onClick: () => handleVipTaskItemExport(id),
      },
      {
        icon: <ListChecks />,
        text: 'Validate participants',
        onClick: () => handleVipTaskItemValidateModalOpen(vipTaskItem),
      }
    );
  }

  return (
    <Box className={vipTaskActionItem}>
      <Typography className={defaultText}>Title: {title}</Typography>
      <Typography className={defaultText}>Type: {type}</Typography>
      <Typography className={defaultText}>Reward: {reward}</Typography>
      <Box className={actionsContainer}>
        <Typography className={defaultText}>Settings:</Typography>
        <BaseMenu
          menuItems={menuItems}
          menuAnchor={menuAnchor}
          isMenuOpened={isMenuOpened}
          handleOpenMenu={handleOpenMenu}
          handleCloseMenu={handleCloseMenu}
        />
      </Box>
    </Box>
  );
};
